import { Component, input, output } from "@angular/core"

@Component({
  imports: [],
  standalone: true,
  template: `
    <div
      tabindex="0"
      class="collapse border border-base-300 bg-base-200"
      [style.border-bottom-left-radius.px]="last() ? undefined : 0"
      [style.border-bottom-right-radius.px]="last() ? undefined : 0"
      [style.border-top-left-radius.px]="first() ? undefined : 0"
      [style.border-top-right-radius.px]="first() ? undefined : 0"
      [style.border-bottom]="last() ? undefined : 'none'"
      (focus)="activated.emit(index())"
    >
      <input 
        type="checkbox"
        [checked]="opened()"
        (change)="activated.emit(index())"
      />
      <div class="collapse-title row-nowrap">
        <div>
          <ng-content select="title-left"/>
        </div>
        <div style="margin-left: auto">
          <ng-content select="title-right"/>
        </div>
      </div>
      <div class="collapse-content">
        <ng-content select="content"/>
      </div>
    </div>
  `,
  selector: "lib-ui-collapse",
})
export class UiCollapseComponent {
  first = input(false)
  last = input(false)
  index = input(-1)
  opened = input(false)
  activated = output<number>()
}
